/**
 *
 * Provides the validation methods for password validation.
 */

import { isString } from 'lodash';

const MINIMUM_PASSWORD_LENGTH = 12;
const MINIMUM_PASSWORD_LENGTH_FOR_LFA = 16;

const COGNITO_SPECIAL_CHARACTERS =
  /\^|\$|\*|\.|\[|\]|{|}|\(|\)|\?|-|"|!|@|#|%|&|\/|\\|,|>|<|'|:|;|\||_|~|`/;

const containsUpperCaseLetter = (password: string) => {
  if (password == null) return false;

  return password.toLowerCase() !== password;
};

const containsLowerCaseLetter = (password: string) => {
  if (password == null) return false;

  return password.toUpperCase() !== password;
};

const containsSpecialCharacter = (password: string) => {
  if (password == null) return false;

  return COGNITO_SPECIAL_CHARACTERS.test(password);
};

const containsNumber = (password: string) => {
  if (password == null) return false;

  return /\d/.test(password);
};

const satisfiesLength = (password: string, minimumLength: number): boolean =>
  password.length >= minimumLength;

const hasNoLeadingOrTrailingWhitespace = (password: string): boolean => {
  if (password == null || !isString(password)) return false;
  return password === password.trim();
};

const isValid = (password: string) => {
  if (password == null) return false;

  if (!isString(password)) return false;
  if (!satisfiesLength(password, MINIMUM_PASSWORD_LENGTH)) return false;
  if (!containsNumber(password)) return false;
  if (!containsSpecialCharacter(password)) return false;
  if (!containsLowerCaseLetter(password)) return false;
  if (!containsUpperCaseLetter(password)) return false;
  if (!hasNoLeadingOrTrailingWhitespace(password)) return false;

  return true;
};

export default {
  MINIMUM_PASSWORD_LENGTH,
  MINIMUM_PASSWORD_LENGTH_FOR_LFA,
  satisfiesLength,
  containsLowerCaseLetter,
  containsUpperCaseLetter,
  containsSpecialCharacter,
  containsNumber,
  hasNoLeadingOrTrailingWhitespace,
  isValid,
};
